import { defaultTheme } from 'da-frontend-shared-ui-components';

export const connectCloudTheme = defaultTheme;
